import {
  getPlayDeatil,
  getLiveUrl,
  saveAction,
  doUseGood,
  doUseGrade,
  getCourseList,
  getActiveComments,
  activityDoUserSetting
} from '@/api'
import {Toast} from 'vant'
export default {
  namespace: true,
  getters: {
    isAuth: (state, getters, rootState) => {
      if (!rootState.userInfo.id) {
        return false
      }
      if (getters.eventInfo && rootState.userInfo.id) {
        return getters.eventInfo.eventTalkUserId === rootState.userInfo.id || state.auth
      }
      return false
    },
    eventInfo: state => {
      return state.activeInfo.eventInfo
    }
  },
  state: {
    auth: false,
    ws: null,
    /* 基础信息 */
    activeInfo: {},
    /* 点赞、评分 */
    action: {
      good: 0,
      grade: 0,
      showGood: false,
      showGrade: false,
      showGradePanel: false
    },
    /* 各种弹出层 */
    panel: {
      showDetail: false, // 活动详情
      showVideoSet: false, // 视频设置
      showRate: false // 活动评分
    },
    /* video相关 */
    video: {
      isLive: true,
      liveisPlaying: false,
      videoisPlaying: false,
      videoisLoading: false, // 点播loading
      showMainScreen: true,
      showSubScreen: true,
      urlList: [],
      doubleUrl: false,
      isFullScreen: false
    },
    // 录像设置
    videoDanmuSet: {
      isOpen: true,
      type: '1', // 1观看全部 2只看标记
      attrId: ''
    },
    /* ======评课========== */
    courseList: [],
    report: {},
    /* 签到 */
    signInfo: {
      showSignBtn: false,
      showSignModal: false,
      time: 0
    },
    /* 验证 */
    checkInfo: {
      showCheckModal: false,
      isOpen: false,
      randomTime: 0
    },
    /* 答题 */
    answer: {
      showTip: false,
      showPanel: false,
      objectType: null,
      objectId: null
    },
    /* 评论设置 */
    comments: {
      liveBarrageOpen: 1,
      videoBarrageOpen: 1,
      commentsOpen: 1
    },
    /* 是否是全屏 */
    isFullScreen: false,
    /* 观看动作记录id */
    lookActionId: ''
  },
  mutations: {
    /* autj */
    setAuth(state, auth) {
      state.auth = auth
    },
    /* ws */
    initWs(state, payload) {
      state.ws = payload
    },
    /* 初始化活动信息 */
    initActiveInfo(state, payload) {
      state.activeInfo = payload
    },
    /* 预处理点赞、评分 */
    deelGoodAndGrate(state, payload) {
      let grade = 0
      if (payload.eventInfo.eventGradeTime !== 0) {
        grade = Number(payload.eventInfo.eventGrade / payload.eventInfo.eventGradeTime).toFixed(1)
      }
      state.action.good = payload.eventInfo.eventGoodCount
      state.action.grade = grade
      state.action.showGood = payload.eventInfo.good
      state.action.showGrade = payload.eventInfo.grade
    },
    /* 后处理点赞、评分 */
    afterDeelGoodAndGrate(state, payload) {
      state.action = {
        ...state.action,
        ...payload
      }
    },
    // 控制panel
    controlPanel(state, payload) {
      state.panel = {
        ...state.panel,
        ...payload
      }
    },
    // 控制video
    controlVideo(state, payload) {
      state.video = {
        ...state.video,
        ...payload
      }
    },
    setVideoDanmuSet(state, payload) {
      state.videoDanmuSet = {
        ...state.videoDanmuSet,
        ...payload
      }
    },
    /* 评课 */
    setCourselist(state, payload) {
      state.courseList = payload
    },
    setReport(state, payload) {
      state.report = {
        ...state.report,
        ...payload
      }
    },
    resetReport(state) {
      state.report = {}
    },
    /* 签到 */
    setSignInfo(state, payload) {
      state.signInfo = {
        ...state.signInfo,
        ...payload
      }
    },
    /* 验证 */
    setCheckInfo(state, payload) {
      state.checkInfo = {
        ...state.checkInfo,
        ...payload
      }
    },
    /* 答题 */
    setAnswerInfo(state, payload) {
      state.answer = {...state.answer, ...payload}
    },
    /* 评论设置 */
    setComments(state, payload) {
      state.comments = payload
    },
    /* 是否是全屏 */
    toggleFullScreen(state) {
      state.isFullScreen = !state.isFullScreen
    },
    closeFullScreen(state, flag) {
      state.isFullScreen = false
    },
    // 新增-增加观看直播，录播动作
    setLookActionId(state, id) {
      state.lookActionId = id
    },
    deleteLookActionId(state) {
      state.lookActionId = ''
    }
  },
  actions: {
    async getAuth({commit}, id) {
      const result = await activityDoUserSetting(id)
      commit('setAuth', result.data)
    },
    /* 获取基本信息 */
    async getActiveInfo({commit, dispatch}, eventId) {
      const result = await getPlayDeatil({eventId})
      if (result) {
        commit('initActiveInfo', result.data)
        commit('deelGoodAndGrate', result.data)
      }
    },
    async fetchLiveUrls({commit}, eventId) {
      const result = await getLiveUrl({id: eventId})
      if (result) {
        let urlList = result.data || []
        urlList = urlList.filter(item => {
          return item.status === '1'
        })
        urlList = urlList.sort(function (a, b) {
          return a.type - b.type
        })
        let doubleUrl = false
        if (urlList.length === 2) {
          doubleUrl = true
        }
        // 如果this.mainVideoElement.addEventListener('waiting'）事件触发后，urlList小于0，将uid清除掉
        if (urlList.length <= 0) {
          commit('deleteLookActionId')
        }
        commit('controlVideo', {urlList, doubleUrl, isLive: true})
      }
    },
    /* 点赞 */
    async handleGood({commit, state}, eventId) {
      const params = {
        eventInfoId: eventId,
        eventActionType: 1,
        actionDevice: 1
      }
      await saveAction(params)
      const result = await doUseGood(eventId)
      if (result) {
        commit('afterDeelGoodAndGrate', {
          good: state.action.good + 1,
          showGood: true
        })
        Toast.success('点赞成功')
      }
    },
    /* 评分 */
    async handleGrade({commit}, {eventId, grade}) {
      const params = {
        actionDevice: 1,
        eventActionType: 2,
        eventInfoId: eventId,
        grade
      }
      await saveAction(params)
      const result = await doUseGrade(eventId)
      if (result) {
        const {eventGrade, eventGradeTime} = result.data
        const grade = Number(eventGrade / eventGradeTime).toFixed(1)
        commit('afterDeelGoodAndGrate', {
          grade,
          showGrade: true
        })
        commit('controlPanel', {showRate: false})
        Toast.success('评分成功')
      }
    },
    /* 获取评课 */
    async getCourseList({commit}, eventId) {
      const result = await getCourseList(eventId)
      if (result) {
        commit('setCourselist', result.data || [])
      }
    },
    /* 评论设置 */
    async getComments({commit}, eventId) {
      const result = await getActiveComments({eventId})
      if (result) {
        let {commentsOpen, videoBarrageOpen, liveBarrageOpen} = result.data
        commentsOpen = commentsOpen || 2
        videoBarrageOpen = videoBarrageOpen || 2
        liveBarrageOpen = liveBarrageOpen || 2
        commit('setComments', {
          liveBarrageOpen,
          videoBarrageOpen,
          commentsOpen
        })
      }
    }
  }
}
